<div class="drop-down-patient" id="style-1" *ngIf="patients.length > 0">
    <div class="table-container" >
        <table>
          <thead>
              <th>Nome</th>
              <th>RESid</th>
              <th>Gênero</th>
              <th>Nascimento</th>
          </thead>
          <tbody>
            <tr (click)="selecPatient(patient)" *ngFor="let patient of patients">
                <td>{{patient.name[0].text}}</td>
                <td>{{patient.identifier[0].value}}</td>
                <td>{{genderMap(patient.gender)}}</td>
                <td>{{patient.birthDate | date: "dd/MM/YYYY"}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    
</div>
<div class="no-patient" *ngIf="patients.length === 0">Paciente não encontrado</div>
